import { render, staticRenderFns } from "./statAppointPingjunshu.vue?vue&type=template&id=466c1ae9&scoped=true"
import script from "./statAppointPingjunshu.vue?vue&type=script&lang=js"
export * from "./statAppointPingjunshu.vue?vue&type=script&lang=js"
import style0 from "./statAppointPingjunshu.vue?vue&type=style&index=0&id=466c1ae9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466c1ae9",
  null
  
)

export default component.exports